module.exports = __webpack_public_path__ + "static/img/QLDFirebirds.2fca507.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/QLDFirebirds.png
// module id = b3kk
// module chunks = 1